import gql from 'graphql-tag';

export const GetLines = gql`
  query dispatchLines($offset: Int, $limit: Int) {
    dispatchLines(offset: $offset, limit: $limit) {
      results {
        id
        abbreviation
        description
        areaId
        areaCode
        defaultMachine
      }
    }
  }
`;

export const GetDispatchTypes = gql`
  query dispatchTypes($offset: Int, $limit: Int) {
    dispatchTypes(offset: $offset, limit: $limit) {
      results {
        id
        code
        description
      }
    }
  }
`;

export const GetDispatchMachines = gql`
  query getDispatchMachines($offset: Int!, $limit: Int!, $lineId: Int!) {
    dispatchMachines(offset: $offset, limit: $limit, lineId: $lineId) {
      results {
        id
        code
        description
      }
    }
  }
`;
